<template>

    <div class="yoga">

        <div class="yoga-text">
            <p>
                {{ $t('txtYogaComment1') }}
            </p>
            <p>    
                {{ $t('txtYogaComment2') }}
            </p>
            <p>
                {{ $t('txtYogaComment3') }}
            </p>
            
        </div>

        <div class="yoga-video">
            <div class="video-player">
                <video :key="localeVideo[$i18n.locale]" class="video" ref="video" width="216" height="384" onclick="this.paused ? this.play() : this.pause();" autoplay loop muted @loadstart="receiveVideoEventloadstart">
                    <source :src="localeVideo[$i18n.locale]" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>

            <div class="audio-toggle">
                {{ $t('labelSound') }} &nbsp;
                <ToggleControl ref="audioToggle" @toggle-event="receiveToggleEvent" />
             </div>
        </div>

    </div>

</template>
  
<script>

    import videoYogaEN from '@/assets/video/ybi-hatha-music-w-1.0.0-rel.mp4'
    import videoYogaES from '@/assets/video/ybi-hatha-voice-esp-w-1.0.0-rel.mp4'

    import ToggleControl from '@/components/controls/ToggleControl.vue'
    import { ref } from 'vue'

    export default {
        name: "YogaLayout",
        components: {
            ToggleControl
        },
        data() {
            return {
                localeVideo: {
                    en: videoYogaEN,
                    es: videoYogaES
                }
            }
        },
        computed: {
            videoElement () {
                return this.$refs.video;
            }, 
        },
        methods: {
            receiveToggleEvent (value) {
                // console.log('EVENT: receiveToggleEvent: ' + value + ' ' + Date.now());
                const refvideo = this.$refs.video
                refvideo.muted = (value == false) ? true : false;
                return true;
            },
            receiveVideoEventloadstart (value) {
                // console.log('EVENT: receiveVideoEventloadstart: ' + value + ' ' + Date.now());
                this.$refs.video.muted = true;
                this.$refs.audioToggle.SetValue(false);
                return true;
            }
        }
    }


</script>

<style>

    .yoga {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-left: 20px;
        margin-right: 60px;
        padding-bottom: 20px;
        /* border: 2px dotted; */
    }

    .yoga-text {
        flex: 10 10 200px;
        font-size: 20px;
        font-style: italic;
        text-align: center;
        align-self: center;
        padding-left: 60px;
        padding-right: 40px;
        /* border: 2px dotted; */
    }

    .yoga-video {
        flex: 1 1 216px;
        margin-right: 60px;
        justify-content: center;
        /* border: 2px dotted; */
    }

    .video-player {

        display: block;
        margin: auto;

        width: 216px;
        height: 384px;
        border-radius: 28px;
        overflow: hidden;
        box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px;

        /*  -webkit-transform: translateZ(0); */
    }

    .video {
        display: block;
        margin: auto;
    }

    .audio-toggle {
        font-size: 12px;
    }

    @media screen and (max-width: 600px) {
        
        .yoga-text {
            flex: 1 1 100px;
            justify-content: center;
            font-size: 12px;
            padding-top: 0px;
            padding-left: 20px;
            padding-right: 30px;
            padding-bottom: 20px;
        }

        .yoga-video {
            margin-left: 40px;
            margin-right: 60px;
        }
    }

</style>
